__turbopack_context__.v({
  "active": "style-module-scss-module__Ill5kq__active",
  "suggestion": "style-module-scss-module__Ill5kq__suggestion",
  "suggestions-container": "style-module-scss-module__Ill5kq__suggestions-container",
});
